export default __webpack_public_path__ + "static/media/f_video.150eba50.svg";